export class StpAbosAccount {
  accountId: string;
  displayname: string;
}
